import { useState } from 'react';

/**
 * Hook for triggering a one-shot CSS animation.
 *
 * @param duration - Duration of the animation in milliseconds
 * @returns [isAnimating, triggerAnimation] - Animation state and trigger function
 *
 * @example
 * const [isAnimating, triggerAnimation] = useAnimation(300);
 *
 * const handleClick = () => {
 *   triggerAnimation();
 *   // ... other click logic
 * };
 */
export const useAnimation = (
  duration: number
): [isAnimating: boolean, triggerAnimation: VoidFunction] => {
  const [isAnimating, setIsAnimating] = useState(false);

  const triggerAnimation = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, duration);
  };

  return [isAnimating, triggerAnimation];
};
